// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"DeliveryAndGuaranteesMessage_messageContainer__GNedH"};